<template>
  <cTable
		branch
  >
  </cTable>
</template>

<script>

import cTable from "@/view/finances/storage_fee";

export default {
  name: "branch_storage_fee",
	components:{
		cTable
	}
};
</script>
